<template>
  <div
    :class="[
      'carousel',
      { 'carousel--stack-on-mobile': stackOnMobile },
      {
        'carousel-vertical': vertical,
        'carousel-text-selectable': !swipeOnDesktop,
      },
    ]"
    :id="carouselIdentifier"
  >
    <div class="carousel-wrapper">
      <ul
        ref="carouselInner"
        class="carousel-inner"
        :style="{
          transform: `translate${this.vertical ? 'Y' : 'X'}(${
            this.currentOffset
          }px)`,
          transition: this.transitionStyle,
          flexBasis: `${this.slideWidth}px`,
          msFlexPreferredSize: `${this.slideWidth}px`,
          visibility: `${this.slideWidth ? 'visible' : 'hidden'}`,
        }"
      >
        <slide v-for="(data, i) in customLandingPageData" :key="i">
          <div class="custom-landing-page-carousel">
            <div class="custom-landing-page-carousel-background-wrapper">
              <div
                class="
                  custom-landing-page-carousel-background-wrapper__previous
                "
                :style="{
                  'background-image': `url('${
                    customLandingPageData.at(i - 1).backgroundSrc
                  }')`,
                }"
                @click="advancePage('backward')"
              ></div>
              <a
                :href="data.link"
                target="_blank"
                class="custom-landing-page-carousel-background-wrapper__current"
                :style="{
                  'background-image': `url('${data.backgroundSrc}')`,
                }"
              ></a>

              <div
                class="custom-landing-page-carousel-background-wrapper__next"
                :style="{
                  'background-image': `url('${
                    customLandingPageData.at(
                      (i + 1) % customLandingPageData.length
                    ).backgroundSrc
                  }')`,
                }"
                @click="advancePage()"
              ></div>
            </div>
            <div class="custom-landing-page-carousel-card" ref="whitebox">
              <navigation
                :show-navigation="showNavigation"
                :autoplay="autoplay"
                @changeSlide="advancePage"
                @toggleAutoPlay="toggleAutoPlay"
                :labels="labels"
                ref="navigation"
              />
              <div class="custom-landing-page-carousel-card-content">
                <p class="custom-landing-page-carousel-card-content__title">
                  {{ data.title }}
                </p>
                <a
                  class="custom-landing-page-carousel-card-content__copy"
                  :href="data.link"
                  target="_blank"
                  v-ellipsis="85"
                >
                  {{ data.copy }}
                </a>
                <p>
                  {{ data.date }}
                </p>
              </div>
            </div>
          </div>
        </slide>
      </ul>

      <pagination v-if="paginationEnabled && pageCount > 0" :labels="labels" />
    </div>
  </div>
</template>

<script>
  import CarouselMixin from './carouselMixin.js';
  import Navigation from '../navigation/navigation.vue';
  import Pagination from '../pagination/pagination.vue';
  import Slide from '../slide/slide.vue';
  import { debounce } from '@Foundation/utilities/timing';
  import { ellipsis } from '@Foundation/directives/ellipsis/ellipsis';

  export default {
    name: 'custom-carousel',
    mixins: [CarouselMixin],
    directives: {
      ellipsis,
    },
    data() {
      return {
        showCustomNavigation: false,
      };
    },
    components: {
      Navigation,
      Pagination,
      Slide,
    },
    methods: {
      getSlideCount() {
        this.slideCount = this.customLandingPageData.length;
        return;
      },

      updateNavigationPosition() {
        const { width, height, x, y } =
          this.$refs.whitebox[this.currentPage].getBoundingClientRect();

        this.$refs.navigation.$el.style.setProperty('width', `${width}px`);
        this.$refs.navigation.$el.style.setProperty('height', `${height}px`);
        this.$refs.navigation.$el.style.setProperty('top', `${y}px`);
        this.$refs.navigation.$el.style.setProperty('left', `${x}px`);
        this.$refs.navigation.$el.style.setProperty('position', `absolute`);

        this.showCustomNavigation = true;
      },
    },

    mounted() {
      /* istanbul ignore else */
      if (!this.$isServer) {
        window.addEventListener('resize', debounce(this.computeCarouselSize, 16));

        if ('ontouchstart' in window) {
          this.$el.addEventListener('touchstart', this.handleMousedown);
          this.$el.addEventListener('touchend', this.handleMouseup);
          this.$el.addEventListener('touchmove', this.handleMousemove);
        }

        /* istanbul ignore else */
        if (this.swipeOnDesktop) {
          this.$el.addEventListener('mousedown', this.handleMousedown);
          this.$el.addEventListener('mouseup', this.handleMouseup);
          this.$el.addEventListener('mousemove', this.handleMousemove);
        }
      }

      eventBus.$on(`${this.carouselIdentifier}-gotoPage`, (page) => {
        this.goToPage(page);
      });

      this.attachMutationObserver();
      this.computeCarouselSize();

      if (this.autoplay) {
        this.startAutoPlay();
      }
    },
  };
</script>

<style lang="scss"  src="./carousel.scss"></style>

